<template>
  <div class="adu" id="AdUnits">
    <!-- <p class="title" name="AdUnits">Ad Units</p> -->
    <div class="main">
      <h4 class="sub-title">We support the below integration methods for monetization:</h4>
      <p class="descript itg-list">{{itgs.join(', ')}}</p>
      <Integration :items="items" />
      <el-row class="adu-info-row">
        <el-col class="adu-text-info" :span="14" :xs="24">
          <div class="adu-text-content">
            <h4 class="adu-title">Customised Monetization Platform for Publisher</h4>
            <p class="adu-descript">We offer customized unified auction platform for our premium publishers. This gives the publishers the flexibility who they want to work with, tap onto more global demand, get higher yields and CPM. </p>
            <p class="adu-descript">Best part is the publisher has the full control on how they want to monetize their inventory.</p>
            <!-- <a href="" @click="handleClickJump" class="adu-descript" style="display:block;">>>Contact Us to know more</a> -->
             <a href="javascript:void(0);" class="adu-descript adu-desc-link" style="display:block;" @click="handleClickJump">>>Contact Us to know more</a>
          </div>
        </el-col>
        <el-col :span="10" :xs="24" class="adu-img">
          <img height="100%" :src="require(`@images/adu_5.png`)" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Integration from "./Integration";
export default {
  name: "AdUnits",
  components: {
    Integration
  },
  data: function () {
    return {
      items: [
        {
          title: 'Unified Auction',
          btText: 'Join In',
          img: 'auction.png'
        },
        {
          title: 'Integrate Our SDK',
          btText: 'Download Now',
          img: 'sdk.png'
        }
      ],
      itgs: ['RTB', 'SDK', 'TAG', 'API', 'Header Bidding']
    };
  },
  methods: {
    handleClickJump() {
      this.$router.push('/contact');
    }
  }
};
</script>
<style lang="scss" scoped>
.adu {
  background: #ffffff;
  position: relative;
  box-shadow: $section-box-shadow;
  .main {
    padding: 1px 0;
    max-width: px2rem(1100);
    margin: 0 auto;
    .sub-title {
      margin-top: px2rem(60);
    }
    .itg-list {
      text-align: center;
      max-width: px2rem(750);
      margin: 0 auto;
      font-size: px2rem(15);
      font-weight: bolder;
    }
    .adu-info-row {
      margin: px2rem(50) auto 0 auto;
      margin-top: px2rem(80);
      max-width: px2rem(800);
      .adu-text-info{
        height: 100%;
        justify-content: center;
        align-items: center;
        display: flex;
        .adu-text-content {
          width: px2rem(500px);
          .adu-title {
            font-size: px2rem(20);
            color: $--color-primary;
            text-align: left;
          }
          .adu-descript {
            font-size: px2rem(14);
            letter-spacing: 1px;
            line-height: 1.6em;
            text-align: left;
            margin: px2rem(8) auto;
          }
          .adu-desc-link {
            color: $--color-primary;
            cursor: pointer;
          }
        }
      }
      .adu-img {
        text-align: right;
        img {
          width: 85%;
        }
      }
    }
    .adu-sp {
      height: px2rem(120);
      .el-button {
        border-radius: px2rem(10);
        font-size: px2rem(16);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        padding: px2rem(15) px2rem(20);
        i {
          font-size: px2rem(17);
        }
      }
    }
  }
}
</style>